<div ngClass.gt-md="container" id="productDetails">
    <div class="bg-color">
        <div fxHide.gt-md fxHide.md fxHide.gt-lg fxHide.lg>
            <div fxLayout="row" class="wishMobile" fxLayoutAlign="end center">
                <calsoft-controls [data]="data" fxLayoutGap="10px"
                [coversionTrackingIdGa]="coversionTrackingIdGa"
                 fxLayoutAlign="end center"
                    [product]="configProductSelected" [configproduct]="product" [buttonArray]="buttonArray"
                    [type]="'wishonly'">
                </calsoft-controls>

            </div>
        </div>

        <calsoft-product-mobile-image [bigImage]="bigImage" [commonImageApi]="commonImageApi" [image]="image"
            [productDetailHeight]="productDetailHeight" [productDetailWidth]="productDetailWidth"
            [productDetailWidthMobile]="productDetailWidthMobile"
            [productDetailHeightMobile]="productDetailHeightMobile" [name]="name"
            [imageList]="imageList"></calsoft-product-mobile-image>


        <calsoft-product-icon fxHide fxShow.lt-md [showGenuineProductIcon]="showGenuineProductIcon"
            [genuineProductText]="genuineProductText" [deliveryTime]="deliveryTime"
            [deliveryDoorStepText]="deliveryDoorStepText" [ColdChain]="ColdChain" [showTimeIcon]="showTimeIcon"
            [deliveryDoorStepIcon]="deliveryDoorStepIcon" [displayColdChain]="displayColdChain"></calsoft-product-icon>


        <div class="prod" fxLayout="row" fxLayout.sm="column" class="pd padding-10" fxLayoutGap="2px">
            <div fxHide fxShow.gt-sm [fxFlex]="productDetailImageWidth" class="product-details">
                <calsoft-product-image3 [name]="name" [configProductSelected]="configProductSelected"
                    [product]="product" [imageList]="imageList" [image]="image"
                    [productDetailHeight]="productDetailHeight" [productDetailWidth]="productDetailWidth"
                    [productDetailWidthMobile]="productDetailWidthMobile" [productDetailPageSubimageHeight]="productDetailPageSubimageHeight"
                    [productDetailHeightMobile]="productDetailHeightMobile"
                    [productIdAddedInCart]="productIdAddedInCart" [data]="data" [zoomImage]="zoomImage"
                    (mouseMoveEvent)="onMouseMove($event)" (leaveMoveEvent)="onMouseLeave($event)"
                    [productDetailImageWidth]="productDetailImageWidth" [productzoom]="productzoom"
                    [imageList]="imageList" [showGenuineProductIcon]="showGenuineProductIcon"
                    [genuineProductText]="genuineProductText" [deliveryTime]="deliveryTime"
                    [deliveryDoorStepText]="deliveryDoorStepText" [ColdChain]="ColdChain" [showTimeIcon]="showTimeIcon"
                    [deliveryDoorStepIcon]="deliveryDoorStepIcon" (zoomImageEvent)="setZoomImage($event)"
                    [displayColdChain]="displayColdChain"></calsoft-product-image3>
            </div>
            <div fxFlex="100" fxFlex.md="100" fxFlex.gt-sm="50" class="product-details1 border"
                ngClass.gt-md="padding-20">
                <div #zoomViewer fxShow="false" fxShow.gt-sm>
                    <mat-card *ngIf="zoomImage" class="zoom-viewer mat-elevation-z0"
                        [ngStyle]="{'background-image': 'url(' + zoomImage + ')'}">
                    </mat-card>
                </div>

                <div fxLayout="row" fxLayoutAlign="space-between center">

                    <div *ngIf="name.length>0">
                        <calsoft-translator [translateValue]="name" [type]="'productsdetails'"></calsoft-translator>

                    </div>

                    <div fxHide.gt-lg fxHide.lg>
                        <div fxLayout="row">

                            <calsoft-share-speed-dial></calsoft-share-speed-dial>
                        </div>
                    </div>
                    <button fxHide.lt-lg [matMenuTriggerFor]="menu" mat-icon-button>

                        <mat-icon>share</mat-icon>
                    </button>
                </div>

                <!-- specific-info-product -->
                <calsoft-specific-info-product [qty]="qty" [prescriptionRequired]="prescriptionRequired"
                    [product]="product" [factBox]="factBox" [faq]="faq" [SIDEEFFECTS]="SIDEEFFECTS"
                    [Commonsideeffects]="Commonsideeffects" [SafetyAdvice]="SafetyAdvice" [HOWTOUSE]="HOWTOUSE"
                    [UsesOf]="UsesOf" [Benefits]="Benefits" [HowWorks]="HowWorks" [Ifmiss]="Ifmiss"
                    [productName]="productName" [MANUFACTURER]="MANUFACTURER" [SALTCOMPOSITION]="SALTCOMPOSITION"
                    [STORAGES]="STORAGES" [factbox]="factbox" [ColdChain]="ColdChain"
                    [productDetailPage]="productDetailPage" [manageStock]="manageStock"
                    [isInStock]="isInStock"></calsoft-specific-info-product>


                <!-- star -->

                <calsoft-star-rate [averageRating]="averageRating"
                    [calculateAvgRating]="calculateAvgRating"></calsoft-star-rate>

                <div *ngIf="data.disablePriceInDetailPage==0">

                    <calsoft-price [specialPrice]="specialPrice" [data]="data" [product]="product" [price]="price"
                        [discountPercentage]="discountPercentage" [units]="units">
                    </calsoft-price>
                </div>



                <div>

                    <div fxLayout="row" fxFlex="100">
                        <div fxFlex="80" *ngIf="data.disableCartInDetailPage==0 &&product.type!='Subscription'">   
                            <div *ngIf="isInStock==1 ">

                            
                                <calsoft-controls [data]="data" [coversionTrackingIdGa]="coversionTrackingIdGa"
                                    *ngIf="(qty>0 && isInStock==1)||(manageStock==0); else elseBlock" fxHide.xs
                                    fxShow.lt-lg [productCustomOption]="productCustomOption"
                                    [productOption]="salesFlatQuoteItemOption" [product]="configProductSelected"
                                    [configproduct]="product" [type]="'addtocart'" [buttonArray]="buttonArray"
                                    [configproduct]="product">
                                </calsoft-controls>
                            </div>

                        </div>


                        <div *ngIf="data.sizeChartEnable==1 && sizeChartId!=null" fxLayout="column" fxLayoutAlign="center center">
                            <calsoft-size-chart-popup [data]="data" [name]="name"
                                [sizeChartId]="sizeChartId"></calsoft-size-chart-popup>
                        </div>

                    </div>

                </div>

                <div>
                    <div fxLayout="row" style="padding-top: 10px;" fxFlex="100">
                        <div fxFlex="100" *ngIf="product.type!='Subscription'">   
                            <div *ngIf="isInStock==1 ">

                                <calsoft-controls [data]="data"
                                [coversionTrackingIdGa]="coversionTrackingIdGa"
                                    *ngIf="(qty>0 && isInStock==1)||(manageStock==0);" fxHide.xs
                                    fxShow.lt-lg [productCustomOption]="productCustomOption"
                                    [productOption]="salesFlatQuoteItemOption" [product]="configProductSelected"
                                    [configproduct]="product" [type]="'navigationButton'" [buttonArray]="buttonArray"
                                    [configproduct]="product">
                                </calsoft-controls>
                            </div>

                        </div>

                    </div>
                </div>


                <div fxLayout="row" *ngIf="isInStock==0">
                    <div fxLayout="column" fxLayoutGap="5px">
                        <h1>Sold Out</h1>
                        <span>This item is currently out of stock</span>
                    </div>
                </div>

                <ng-template #elseBlock>

                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="2px">
                        <div fxLayout="row">
                            <h2>Sold Out</h2>
                        </div>
                        <div fxLayout="row" class="padding-3" fxFlex>
                            <span>This item is currently out of stock</span>

                        </div>
                        <div fxLayout="row" fxFlex>

                            <button mat-raised-button (click)="initOutStockFunction()" color="warn"
                                class="btn btn-small btn-info padding-10" type="button" data-bind="click: ok">
                                Notify Me
                            </button>

                        </div>

                    </div>

                </ng-template>



                <div fxLayout="row">
                    <div fxFlex="75" fxFlex.lt-sm="100" fxLayout="column" fxLayoutGap="5px">

                    </div>

                    <div fxFlex="25" fxHide fxShow.gt-sm>

                    </div>
                </div>



                <ng-container style="margin-left: 5px;" *ngIf="!showNewConfig; else newconfig">
                    <div fxLayout="row" style="margin-left: 5px;">
                        <ng-container *ngIf="configattributeType==1;">
                            <div [style.padding-top]="configurationDropDownList.size==0 ? '0px' : '10px'" fxLayout="row"
                                *ngFor="let item of configurationDropDownList | keyvalue">
                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>
                                        {{item.key.replace('_', ' ') }}
                                    </mat-label>
                                    <mat-select (selectionChange)="getConfigProductId($event.value,i)"
                                        [disableOptionCentering]="true" [formControl]="dropDownValue">
                                        <mat-option [value]="object" *ngFor="let object of item.value;let i=index ">
                                            {{object |splitbyHash}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </ng-container>


                        <ng-container *ngIf="configattributeType==2;">

                            <!-- <span class="mtb10">

                                <div class="size mtb10" fxLayoutGap="5px" fxLayout="column"
                                    *ngFor="let item of configurationDropDownList | keyvalue">
                                    <div fxFlex fxLayout="row">
                                        <span> {{item.key}}:</span>
                                    </div>

                                    <div fxFlex fxLayout="row">
                                        <div class="brStyle" fxLayout="row wrap" fxLayoutGap="5px">
                                            <div fxFlex="18" *ngFor="let object of item.value;let i=index;"
                                                class="imagesProduct" [class.highlightedImage]="firstIndex ==i"
                                                [class.highlightedImage1]="firstIndex !=i" fxLayout="column"
                                                fxLayoutAlign="center center">
                                                <div class="imagesPro padding-3">
                                                    <a (click)="getConfigProductId(object,i)">
                                                        <img [alt]="name" class="imgH"
                                                            [src]="getImageproductIdOld(object)"
                                                            onerror="this.src='assets/images/products/noImage/no-image.png';"
                                                           >
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </span> -->

                            <span class="mtb10">

                                <div class="size,mtb10" fxLayoutGap="5px"
                                    *ngFor="let object  of configurationDropDownList | keyvalue">
                                    <span>{{object.key.replace('_', ' ') }}:</span>
                                    <div fxFlex fxLayout="row">
                                        <div class="brStyle" fxLayout="row wrap" fxLayoutGap="5px">
                                            <div fxflex="33.33" *ngFor="let size of object.value;let i=index;"
                                                class="imagesProduct" [class.highlightedImage]="i == firstIndex"
                                                fxLayout="column" fxLayoutAlign="center center">
                                                <div class="imagesPro padding-3">
                                                    <a (click)="getConfigProductId(size,i)">


                                                        <img [alt]="name" class="imgH"
                                                            [src]="getImageproductIdOld(size)"
                                                            onerror="this.src='assets/images/products/noImage/no-image.png';">
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </span>




                        </ng-container>

                        <ng-container *ngIf="configattributeType==4;">
                            <span class="mtb10" *ngFor="let item of configurationDropDownList | keyvalue">

                                <div class="size,mtb10" fxLayoutGap="5px">
                                    <span class="fw-500"> {{item.key.replace('_', ' ') }}:</span>
                                    <button [class.highlightedImage]="firstIndex ==i" fxLayoutGap="5px"
                                        mat-raised-button (click)="getConfigProductId(object,i)"
                                        *ngFor="let object of item.value;let i=index;"
                                        [style.background]="object |splitbyHash">&nbsp;</button>
                                </div>
                            </span>

                        </ng-container>

                        <ng-container *ngIf="configattributeType==3;">
                            <span class="mtb10" *ngFor="let item of configurationDropDownList | keyvalue">

                                <div class="size mtb10" fxLayoutGap="5px">
                                    <span class="fw-500 mtb10"> {{item.key.replace('_', ' ') }}:&nbsp;</span>
                                    <button [class.highlightedImage]="firstIndex ==i" fxLayoutGap="5px"
                                        mat-raised-button (click)="getConfigProductId(object,i)"
                                        *ngFor="let object of item.value;let i=index;">
                                        {{object |splitbyHash}}
                                    </button>
                                </div>
                            </span>

                        </ng-container>

                    </div>
                </ng-container>


                <ng-template #newconfig>
                    <div fxLayout="row" style="margin-left: 5px;" fxLayoutGap="5px">
                        <ng-container>

                            <ng-container *ngIf="configurationDropDownList[0].configAttributeType==1;
       ">


                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>
                                        {{configurationDropDownList[0].key}}
                                    </mat-label>


                                    <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value"
                                        [disableOptionCentering]="true">
                                        <mat-option
                                            (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')"
                                            [value]="item.value"
                                            *ngFor="let item of configurationDropDownList;let i=index;">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                            </ng-container>


                            <ng-container *ngIf="configurationDropDownList[0].configAttributeType==4;">

                                <span class="mtb10">

                                    <div class="size,mtb10" fxLayoutGap="5px">
                                        <span class="fw-500">{{configurationDropDownList[0].key}}:</span>
                                        <button [class.highlightedImage]="i == firstIndex" fxLayoutGap="5px"
                                            mat-raised-button (click)="getConfigProductIdButton(i,'firstIndex')"
                                            *ngFor="let size of configurationDropDownList;let i=index;"
                                            [style.background]="size.value">&nbsp;</button>
                                    </div>
                                </span>

                            </ng-container>

                            <ng-container *ngIf="configurationDropDownList[0].configAttributeType==5;">

                                <span class="mtb10">

                                    <div class="size,mtb10" fxLayoutGap="5px">
                                        <span class="fw-500">{{configurationDropDownList[0].key}}:</span>
                                        <button fxLayoutGap="5px" mat-mini-fab
                                            (click)="getConfigProductIdButton(i,'firstIndex')"
                                            *ngFor="let size of configurationDropDownList;let i=index;"
                                            [style.background]="size.value">
                                            <mat-icon *ngIf="i == firstIndex">done</mat-icon>
                                        </button>
                                    </div>
                                </span>

                            </ng-container>

                            <ng-container *ngIf="configurationDropDownList[0].configAttributeType==2;">
                                <span class="mtb10">

                                    <div class="size,mtb10" fxLayoutGap="5px">
                                        <span>{{configurationDropDownList[0].key}}:</span>
                                        <div fxFlex fxLayout="row">
                                            <div class="brStyle" fxLayout="row wrap" fxLayoutGap="5px">
                                                <div fxflex="33.33"
                                                    *ngFor="let size of configurationDropDownList;let i=index;"
                                                    class="imagesProduct" [class.highlightedImage]="i == firstIndex"
                                                    fxLayout="column" fxLayoutAlign="center center">
                                                    <div class="imagesPro padding-3">
                                                        <a (click)="getConfigProductIdButton(i,'firstIndex')">


                                                            <img [alt]="name" class="imgH"
                                                                [src]="getImageproductId(size.productId)"
                                                                onerror="this.src='assets/images/products/noImage/no-image.png';">
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </span>

                            </ng-container>



                            <ng-container *ngIf="configurationDropDownList[0].configAttributeType==3;">
                                <span class="mtb10">

                                    <div class="size,mtb10" fxLayoutGap="5px">
                                        <span>{{configurationDropDownList[0].key}}:</span>

                                        <button fxLayoutGap="5px" mat-raised-button
                                            (click)="getConfigProductIdButton(i,'firstIndex')"
                                            [class.highlightedImage]="firstIndex ==i "
                                            *ngFor="let size of configurationDropDownList;let i=index;">

                                            {{size.value}}</button>
                                    </div>
                                </span>

                            </ng-container>


                        </ng-container>
                    </div>
                    <div fxLayout="row" style="margin-left: 5px;">
                        <ng-container fxLayout="row">
                            <ng-container *ngIf="configurationDropDownList[0]
      ['recursuive'][0].configAttributeType==1;">

                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>
                                        {{configurationDropDownList[0]
                                        ['recursuive'][0].key}}
                                    </mat-label>
                                    <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
        .recursuive[secondIndex].value" [disableOptionCentering]="true">
                                        <mat-option
                                            (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')"
                                            [value]="item1.value" *ngFor="let item1 of configurationDropDownList[firstIndex]
  ['recursuive'];let j=index;">
                                            {{item1.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </ng-container>


                            <ng-container *ngIf="configurationDropDownList[0]
     ['recursuive'][0].configAttributeType==2;">
                                <span class="mtb10">

                                    <div class="size,mtb10" fxLayoutGap="5px">
                                        <span>{{configurationDropDownList[0]
                                            ['recursuive'][0].key}}:</span>
                                        <div fxFlex fxLayout="row">
                                            <div class="brStyle" fxLayout="row wrap" fxLayoutGap="5px">
                                                <div fxflex="33.33" *ngFor="let size of  configurationDropDownList[firstIndex]
                ['recursuive'];let j=index;" class="imagesProduct" [class.highlightedImage]="secondIndex ==j"
                                                    fxLayout="column" fxLayoutAlign="center center">
                                                    <div class="imagesPro padding-3">

                                                        <a (click)="getConfigProductIdButton(j,'secondIndex')">

                                                            <img [alt]="name" class="imgH"
                                                                [src]="getImageproductId(size.productId)"
                                                                onerror="this.src='assets/images/products/noImage/no-image.png';">
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </span>

                            </ng-container>

                            <ng-container *ngIf="configurationDropDownList[0]
    ['recursuive'][0].configAttributeType==4;">

                                <span class="mtb10">

                                    <div class="size,mtb10" fxLayoutGap="5px">
                                        <span class="fw-500"> {{configurationDropDownList[0]
                                            ['recursuive'][0].key}}:</span>
                                        <button [class.highlightedImage]="secondIndex ==j" fxLayoutGap="5px"
                                            mat-raised-button (click)="getConfigProductIdButton(j,'secondIndex')"
                                            *ngFor="let size of configurationDropDownList[firstIndex]
        ['recursuive'];let j=index; " [style.background]="size.value">&nbsp;</button>
                                    </div>
                                </span>

                            </ng-container>

                            <ng-container *ngIf="configurationDropDownList[0]
    ['recursuive'][0].configAttributeType==5;">

                                <span class="mtb10">

                                    <div fxLayoutGap="5px">
                                        <span> {{configurationDropDownList[0]
                                            ['recursuive'][0].key}}:</span>
                                        <button [class.highlightedImage]="secondIndex ==j" mat-mini-fab
                                            (click)="getConfigProductIdButton(j,'secondIndex')" *ngFor="let size of configurationDropDownList[firstIndex]
        ['recursuive'];let j=index; " [style.background]="size.value">
                                            &nbsp;</button>
                                    </div>
                                </span>

                            </ng-container>



                            <ng-container *ngIf="configurationDropDownList[0]
    ['recursuive'][0].configAttributeType==3;">
                                <span class="mtb10">

                                    <div class="size,mtb10" fxLayoutGap="5px">
                                        <span class="fw-500"> {{configurationDropDownList[0]
                                            ['recursuive'][0].key}}:</span>
                                        <button [class.highlightedImage]="secondIndex ==j" fxLayoutGap="5px"
                                            mat-raised-button (click)="getConfigProductIdButton(j,'secondIndex')"
                                            *ngFor="let size of configurationDropDownList[firstIndex]
        ['recursuive'];let j=index;">{{size.value}}</button>
                                    </div>
                                </span>

                            </ng-container>
                        </ng-container>
                    </div>

                </ng-template>



                <div [ngStyle]="{'margin-top':!showNewConfig ? '10px' : '0px' }" fxLayout="column" fxLayoutGap="10px">



                    <calsoft-addition-product [spec]="description"></calsoft-addition-product>

                    <calsoft-product-details [spec]="spec" [title]="'Product Details'">

                    </calsoft-product-details>


                    <!-- <calsoft-size-chart [sizeId]="sizeChartId"></calsoft-size-chart> -->


                    <div style="padding-top: 10px;" *ngIf="MapLink && MapLink?.length > 0">
                        <div class="map-container" (click)="getDirections(MapLink)">
                            <img src="assets/images/map/map.jpg" width="100%" height="250px" alt="map">
                            <div class="overlay1">
                                <p style="color: white;">Tap on the map to get directions</p>
                            </div>
                        </div>
                    </div>


                    <div fxFlex="100" *ngIf="product.type!='Subscription'">   
                        <div *ngIf="isInStock==1">
    
                            <calsoft-controls [data]="data"
                            [coversionTrackingIdGa]="coversionTrackingIdGa"
                                *ngIf="(qty>0 && isInStock==1)||(manageStock==0);" fxHide fxShow.lt-sm
                                 [productCustomOption]="productCustomOption"
                                [productOption]="salesFlatQuoteItemOption" [product]="configProductSelected"
                                [configproduct]="product" [type]="'navigationButton'" [buttonArray]="buttonArray"
                                [configproduct]="product">
                            </calsoft-controls>
                        </div>
    
                    </div>

                    <ng-container *ngIf="data.enableEnquire==1">
                        <div>
                            <button mat-raised-button (click)="generateWhatsAppMessage()" class="primary block"
                                style="color:white;">
                                <img style="height: 24px; color: white;" [alt]="'Enquire About' + productName"
                                    src="assets/icons/whatsapp.svg">
                                Enquire About {{productName}}
                            </button>
                        </div>
                    </ng-container>

                    <calsoft-side-effects [list]="UsesOf" [list1]="Benefits" [title1]="'BENEFITS OF'+ productName"
                        [title]="'USES OF'+ productName"></calsoft-side-effects>

                    <calsoft-side-effects [list]="SIDEEFFECTS" [list1]="Commonsideeffects"
                        [title1]="'Common side effects '+ productName"
                        [title]="'SIDE EFFECTS'+ productName"></calsoft-side-effects>


                    <calsoft-answer-product [list]="HOWTOUSE" [title]="'HOW TO USE '+ productName ">
                    </calsoft-answer-product>

                    <calsoft-answer-product [list]="HowWorks" [title]="'How '+ productName +' WORKS'">
                    </calsoft-answer-product>



                    <calsoft-safety-advice [list]="SafetyAdvice" [title]="'SAFETY ADVICE'"
                        [PregnancyInteraction]="PregnancyInteraction"
                        [BreastfeedingInteraction]="BreastfeedingInteraction" [DrivingInteraction]="DrivingInteraction"
                        [KidneyInteraction]="KidneyInteraction" [LiverInteraction]="LiverInteraction"
                        [alcoholInteraction]="alcoholInteraction"></calsoft-safety-advice>

                    <calsoft-answer-product [list]="Ifmiss" [title]="'WHAT IF YOU FORGET TO TAKE '+ productName">
                    </calsoft-answer-product>


                    <calsoft-medical-additional-product [list]="factBox" [title]="'Fact Box'">
                    </calsoft-medical-additional-product>




                    <calsoft-qa-product-component [list]="faq" [title]="'FAQs'">
                    </calsoft-qa-product-component>




                    <calsoft-review-rating [reviewDetail]="reviewDetail"></calsoft-review-rating>

                    <calsoft-video [videoAvaliable]="videoAvaliable" [videourl]="videourl"></calsoft-video>


                </div>
            </div>




        </div>

    </div>



    <div [class.container]="data.layoutDisplayTypeInDetailpage != '1'" *ngIf="init">
        
        <calsoft-layout [value]="3" [homePageData]="homePageBuilder" [type]="2"></calsoft-layout>
    </div>

    <div id="productDetails" class="linkPadding" *ngIf="relatedProductsList?.length > 0 ">

        <calsoft-product-carousel [data]="data" [heightMobile]="productImageHeightMob"
            [widthMobile]="productImageWidthMob" [height]="productImageHeight" [width]="productImageWidth"
            [imageType]="productImageType" [showConfigurableDropdown]="showConfigurableDropdown"
            [showCartIcon]="showCartIcon" [showCartIncremented]="showCartIncremented" [type]="'product'"
            [header]="relatedProductsText" [products]="relatedProductsList">
        </calsoft-product-carousel>
    </div>

    <div id="productDetails" class="linkPadding" *ngIf="upSellsProductsList?.length > 0 ">

        <calsoft-product-carousel [heightMobile]="productImageHeightMob" [widthMobile]="productImageWidthMob"
            [data]="data" [height]="productImageHeight" [width]="productImageWidth" [imageType]="productImageType"
            [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon"
            [showCartIncremented]="showCartIncremented" [type]="'product'" [header]="upSellProductsText"
            [products]="upSellsProductsList">
        </calsoft-product-carousel>
    </div>

    <div id="productDetails" class="linkPadding" *ngIf="crossSellsProductsList?.length > 0 ">

        <calsoft-product-carousel [heightMobile]="productImageHeightMob" [widthMobile]="productImageWidthMob"
            [data]="data" [height]="productImageHeight" [width]="productImageWidth" [imageType]="productImageType"
            [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon"
            [showCartIncremented]="showCartIncremented" [type]="'product'" [header]="crossSellProductsText"
            [products]="crossSellsProductsList">
        </calsoft-product-carousel>
    </div>

    <div id="productDetails" class="linkPadding" *ngIf="recentlyViewedProducts.length > 0 ">

        <calsoft-product-carousel [heightMobile]="productImageHeightMob" [widthMobile]="productImageWidthMob"
            [data]="data" [height]="productImageHeight" [width]="productImageWidth" [imageType]="productImageType"
            [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon"
            [showCartIncremented]="showCartIncremented" [type]="'product'" [urlNavigation]="false"
            [header]="recentlyViewedProductsText" [products]="recentlyViewedProducts">
        </calsoft-product-carousel>
    </div>


    <div class="padB60">

    </div>




    <mat-menu #menu="matMenu">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
            <div class="padding-10" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
                <button (click)="copy()" class="shareIcon" mat-icon-button>
                    <mat-icon style="color: gray">content_copy</mat-icon>
                </button>
                <button (click)="whatsapp()" mat-icon-button class="shareIcon">
                    <!-- <mat-icon style="color: green">
                        whatsapp
                    </mat-icon> -->
                    <img style="height: 24px;" src="assets/icons/whatsapp.svg" alt="whatsapp">
                </button>
                <!-- <button (click)="facebook()" mat-icon-button class="shareIcon">
                    <img style="height: 24px;" src="assets/logo/facebook.png" alt="facebook">

                </button> -->

            </div>
        </div>
    </mat-menu>
</div>


<ng-template #notify>

    <div class="index-head primary">
        <span>Notify Me</span>
    </div>

    <form [formGroup]="secondFormGroup">
        <div class="padding-10">

            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="customerName" required>
                    <mat-error *ngIf="secondFormGroup.controls.customerName.errors?.required">
                        Please fill out this field.
                    </mat-error>

                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email" required>
                    <mat-error *ngIf="secondFormGroup.controls.email.errors?.required">
                        Please fill out this field.
                    </mat-error>

                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                    <mat-label>Phone No</mat-label>
                    <input numberOnly [autocomplete]="'off'" trim="blur" matInput formControlName="phone" minlength="10"
            maxlength="10" required>
            <mat-error *ngFor="let validation of form_validation_messages.phone">
              <mat-error class="error-message"
                *ngIf="secondFormGroup.controls['phone'].hasError(validation.type) && (secondFormGroup.controls['phone'].dirty || secondFormGroup.controls['phone'].touched)">
                {{validation.message}}
              </mat-error>
            </mat-error>

                </mat-form-field>
            </div>
        </div>
    </form>
    <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
        <button mat-raised-button mat-dialog-close tabindex="-1">Cancel</button>
        <button [disabled]="textAccount !='OK'" (click)=" submitOutOfStockPopup()" mat-raised-button>
            {{textAccount}}
            <mat-icon *ngIf="textAccount !='OK' ">
                <mat-spinner color="primary" diameter="20">
                </mat-spinner>
            </mat-icon></button>
    </div>
</ng-template>
<footer *ngIf="data.disableCartInDetailPage==0" fxHide fxShow.lt-sm class="positionFix11 mat-elevation-z6 ">
    <calsoft-controls [data]="data" [coversionTrackingIdGa]="coversionTrackingIdGa" *ngIf="(qty!=0||manageStock==0)
    &&isInStock==1" [buttonArray]="buttonArray" [product]="configProductSelected"
        [productCustomOption]="productCustomOption" [productOption]="salesFlatQuoteItemOption" [configproduct]="product"
        [productName]="productName" [type]="'addtocart'" [type]="'addtocart'">
    </calsoft-controls>
</footer>